
export default class NestedAccordion {

    constructor() {
        this.settings = {
            el: document.getElementsByClassName('js-nested-accordion-btn')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        let i;
        for (i = 0; i < this.settings.el.length; i++) {

            this.settings.el[i].addEventListener('click', (e) => {
                const panel = e.currentTarget.nextElementSibling;

                e.currentTarget.classList.toggle('active');
                panel.classList.toggle('open');

                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                }
                else {
                    if(panel.closest('.accordion-parent')) {
                        let parent = panel.closest('.accordion-parent');
                        let parentHeight = parent.scrollHeight + panel.scrollHeight + 'px';
                        parent.style.maxHeight = parentHeight;
                    }
                    panel.style.maxHeight = panel.scrollHeight + 'px';
                }
            });

        }

    }

};

new NestedAccordion();